<template>
    <template v-if="showLogo && !notAllowedInThemes.includes(portfolio.templateSettings.theme) && !portfolio.templateSettings.theme.includes('profile_')">
        <AnimationWrapper
            :animation-style="animationSettings?.animationStyle !== 'NONE' ? 'FADE_IN' : null"
        >
            <template #animationContent>
                <div v-if="!checkLocation"
                     class="navbar-logo view">
                    <img :src="logoUrl"
                         :height="logoHeight"
                         alt="Portfolio logo">
                </div>
                <a v-else @click="(evt) => homeNavigation(evt)" class="navbar-logo view">
                    <img :src="logoUrl"
                         :height="logoHeight"
                         alt="Portfolio logo">
                </a>
            </template>
        </AnimationWrapper>
    </template>
    <template v-else-if="showOwnerId">
        <template v-if="portfolio.templateSettings.theme !== 'theme_sixteen'">
            <AnimationWrapper>
                <template #animationContent>
                    <div v-if="!checkLocation" class="navbar-id">{{ userName }}</div>
                    <a v-else @click="(evt) => homeNavigation(evt)" class="navbar-id">{{ userName }}</a>
                </template>
            </AnimationWrapper>
        </template>
    </template>
</template>

<script>
import AnimationWrapper from "../../../../common/components/AnimationWrapper.vue";
import {mapGetters} from "vuex";
import {getPortfolioGenerationPreviewPath} from "@/scripts/view/portfolio/generationPreview.js";

export default {
    name: "GetHeroPortfolioLogo",
    components: {
        AnimationWrapper
    },
    methods: {
        homeNavigation(evt) {
            evt.preventDefault();
            const homeRoute = getPortfolioGenerationPreviewPath(this.$route)
                || (this.rootIsOwnDomain()
                ? "/"
                : `/${this.portfolio.shortId}`);
            this.$router.push(homeRoute)
            this.viewData.navOpen = false;
        },
        rootIsOwnDomain() {
            return this.portfolio.ownDomainAddress && location.origin.includes(this.portfolio.ownDomainAddress);
        },
    },
    computed: {
        ...mapGetters("view", ["viewData"]),
        ...mapGetters("design", ["animationSettings"]),
        user() {
            return this.viewData.user
        },
        portfolio() {
          return this.viewData.portfolio
        },
        resolvedLogo() {
            return this.portfolio?.logo || this.portfolio?.templateSettings?.logo || null;
        },
        logoUrl() {
            const logo = this.resolvedLogo;
            if (!logo) return null;
            if (logo.media) return logo.media.croppedImageUrl || logo.media.url;
            if (logo.image) return logo.image.url;
            return null;
        },
        logoHeight() {
            const logo = this.resolvedLogo;
            if (!logo) return 48;
            const height = logo.media ? logo.media.height : (logo.image ? logo.image.height : null);
            return height || 48;
        },
        showLogo() {
            const logo = this.resolvedLogo;
            if (!logo) return false;
            const mode = logo.mode || (logo.image?.url ? "Logo" : "None");
            return mode === "Logo" && !!this.logoUrl;
        },
        notAllowedInThemes() {
            return ['theme_one', 'theme_two', 'theme_three', 'theme_six', 'theme_seven', 'theme_eleven']
        },
        checkLocation() {
            return window.location.pathname.includes('/p/')
        },
        showOwnerId() {
            return this.portfolio.templateSettings.navigation.navigationItems.ownerId.visible
        },
        userName() {
            if(this.viewData.portfolio.isTemplatePortfolio) {
                if(this.viewData.portfolioTemplate) {
                    return this.viewData.portfolioTemplate.defaults.persona
                }
            }
            return this.user.name
        }
    }
}
</script>

<style lang="scss" scoped>
    .navbar-id,
    .navbar-logo {
        z-index: 2;
        position: relative;
    }

    .navbar-id,
    .navbar-id a {
        &:hover {
            font-weight: bold;
            color: var(--hero-nav-button-text-color-hover);
            cursor: pointer;
        }
    }
</style>
